import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhom() {
  return <section className="w-full bg-[#FAF8FF] py-16 md:py-24 px-6 border-t border-purple-50" data-id="element-119">
      <div className="max-w-5xl mx-auto" data-id="element-120">
        <FadeIn data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-serif text-night-900 text-center mb-12 md:mb-16" data-id="element-122">
            Este método es para ti si…
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-123">
          <FadeIn delay={0.1} data-id="element-124">
            <div className="bg-green-50/50 p-6 md:p-8 rounded-3xl border border-green-100 h-full" data-id="element-125">
              <h3 className="text-xl md:text-2xl font-serif text-night-900 mb-6 md:mb-8 flex items-center" data-id="element-126">
                <span className="bg-green-100 text-green-700 p-2 rounded-lg mr-3 md:mr-4 text-sm md:text-base" data-id="element-127">
                  Sí es para ti
                </span>
              </h3>
              <ul className="space-y-4 md:space-y-6" data-id="element-128">
                {['Te acuestas agotada pero tu mente no para de pensar', 'Te despiertas en la madrugada y te cuesta volver a dormirte', 'Sientes que el cansancio ya es tu estado "normal"', 'Has probado tés, melatonina o apps de meditación... con resultados parciales', 'Tienes muchas responsabilidades y poco tiempo para "trabajar en ti"', 'Quieres una solución práctica, no otro libro que no vas a terminar'].map((item, i) => <li key={i} className="flex items-start" data-id="element-129">
                    <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-green-500 mr-3 md:mr-4 flex-shrink-0 mt-0.5" data-id="element-130" />
                    <span className="text-sm md:text-base text-slate-700 leading-relaxed" data-id="element-131">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-132">
            <div className="bg-red-50/50 p-6 md:p-8 rounded-3xl border border-red-100 h-full" data-id="element-133">
              <h3 className="text-xl md:text-2xl font-serif text-night-900 mb-6 md:mb-8 flex items-center" data-id="element-134">
                <span className="bg-red-100 text-red-700 p-2 rounded-lg mr-3 md:mr-4 text-sm md:text-base" data-id="element-135">
                  NO es para ti si
                </span>
              </h3>
              <ul className="space-y-4 md:space-y-6" data-id="element-136">
                {['Tienes un diagnóstico médico de insomnio severo que requiere tratamiento especializado', 'Buscas una solución mágica sin ningún compromiso de tu parte', 'No estás dispuesta a dedicar 10–15 minutos por noche durante 7 noches'].map((item, i) => <li key={i} className="flex items-start" data-id="element-137">
                    <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-400 mr-3 md:mr-4 flex-shrink-0 mt-0.5" data-id="element-138" />
                    <span className="text-sm md:text-base text-slate-700 leading-relaxed" data-id="element-139">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}